/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { C as ColorVariants } from './constants-c94b83bd.js';

const DHL_SLIDER_COLOR_VARIANT = {
    RED: ColorVariants.red,
    BLACK: ColorVariants.black,
    YELLOW: ColorVariants.yellow,
    GRAY: ColorVariants.gray,
};
var DhlSliderVariant;
(function (DhlSliderVariant) {
    DhlSliderVariant["HORIZONTAL"] = "horizontal";
    DhlSliderVariant["VERTICAL"] = "vertical";
    DhlSliderVariant["SPAN"] = "span";
})(DhlSliderVariant || (DhlSliderVariant = {}));
var DhlSliderThumbPositionKey;
(function (DhlSliderThumbPositionKey) {
    DhlSliderThumbPositionKey["FIRST"] = "thumbPosition";
    DhlSliderThumbPositionKey["SECOND"] = "secondThumbPosition";
})(DhlSliderThumbPositionKey || (DhlSliderThumbPositionKey = {}));
const DHL_SLIDER = {
    COLOR_VARIANT: DHL_SLIDER_COLOR_VARIANT,
};
const DHL_SLIDER_HORIZONTAL_VARIANT_HEIGHT = 4;
const DHL_SLIDER_VERTICAL_VARIANT_HEIGHT = 320;

export { DhlSliderVariant as D, DhlSliderThumbPositionKey as a, DHL_SLIDER as b, DHL_SLIDER_HORIZONTAL_VARIANT_HEIGHT as c, DHL_SLIDER_VERTICAL_VARIANT_HEIGHT as d };

//# sourceMappingURL=constants-6bf85e64.js.map